<div class="stick-top">
  <mat-toolbar><mat-icon>storage</mat-icon> Databases</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/cmdbDatabases/0">
      <mat-icon aria-label="Create a new Database">add</mat-icon>
      Create a new Database
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">DB Name<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Application<micro-select-pagination apiUrl="/domain/cmdbApplications" [(id)]="filter.applicationId" [defaultOption]="selectedApplication" (objectChange)="selectedApplication = $event" placeholder="Application" [required]="false"></micro-select-pagination></div></th>
      <th><div class="vbox">Environment<micro-environment-select [(environmentId)]="filter.environmentId" [required]="false"></micro-environment-select></div></th>
      <th><div class="vbox">SQL Server Type<micro-sql-type-select [(sqlServerTypeId)]="filter.sqlServerTypeId" [required]="false"></micro-sql-type-select></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/cmdbDatabases/{{element.id}}">{{element.name}}</a></td>
      <td><a routerLink="/cmdbApplications/{{element.applicationId}}">{{applicationNames.get(element.applicationId) || element.applicationId}}</a></td>
      <td><micro-environment-lookup [environmentId]="element.environmentId"></micro-environment-lookup></td>
      <td>{{lookupService.lookup('sql', 'sqlServerTypes', element.sqlServerTypeId)}}</td>
      <td>{{element.description}}</td>
      <td>{{element.active}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
